// @flow

import type {
  TrackingModule,
  TrackingAction,
} from "mmb/services/tracking/constants/trackingEventTypes"

// MODULES
export const GeneralModule: TrackingModule = "General"
export const InsuranceModule: TrackingModule = "Insurance"
export const RefundModule: TrackingModule = "Refund"
export const SeatingModule: TrackingModule = "Seating"
export const PaymentBannerModule: TrackingModule = "PaymentBanner"
export const ContactDetailsModule: TrackingModule = "Contact details"
export const InvoiceModule: TrackingModule = "Invoice"
export const ScheduleChangesModule: TrackingModule = "Schedule changes"
export const ThankyouModule: TrackingModule = "Thank you"
export const AncillaryModule: TrackingModule = "Ancillary"
export const PaymentModule: TrackingModule = "Payment"
export const SpecialAssistanceModule: TrackingModule = "Special Assistance"
export const SportsEquipmentsModule: TrackingModule = "Sports Equipments"
export const PetPassengersModule: TrackingModule = "Pet Passengers"
export const MusicalInstrumentsModule: TrackingModule = "Musical Instruments"
export const ItineraryChangeModule: TrackingModule = "Itinerary Change"
export const BaggageModule: TrackingModule = "Baggage"
export const MealsModule: TrackingModule = "Meals"

/*
 * ACTIONS - for manual tracking via mmbTrack.js
 * pls always make actions in convention noun + verb (e.g. button clicked)
 */
export const ContinueClickAction: TrackingAction = {
  action: "continue clicked",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}
export const ModalOpenAction: TrackingAction = {
  action: "modal opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}
export const ModalCloseAction: TrackingAction = {
  action: "modal closed",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}
export const DownloadClickAction: TrackingAction = {
  action: "download clicked",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}
export const InvalidDataReceiveAction: TrackingAction = {
  action: "invalid data received",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
export const ErrorOccurredAction: TrackingAction = {
  action: "error occurred",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const PaymentBannerDisplayedAction: TrackingAction = {
  action: "black payment banner displayed",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const UnknownSeatingFeatureReceived: TrackingAction = {
  action: "unknown seating feature received from BE",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const BaggageWithoutCombinationReceived: TrackingAction = {
  action: "baggage without combination received from BE",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const BaggagePriorityBoardingFiltered: TrackingAction = {
  action: "baggage priority boarding filtered",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const OpenCreditFaqAction: TrackingAction = {
  action: "credit faq opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const OpenBaggageFaqAction: TrackingAction = {
  action: "baggage faq opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const AcceptSelectedBaggageAction: TrackingAction = {
  action: "selected baggage accepted",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const BaggageStepBackAction: TrackingAction = {
  action: "step back button clicked",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const CheckoutBaggageAction: TrackingAction = {
  action: "checkout button clicked",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const SelectPassengerBaggageAction: TrackingAction = {
  action: "passenger opened baggage picker",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const OpenPhoneModalAction: TrackingAction = {
  action: "phone modal opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const SelectActionAction: TrackingAction = {
  action: "action selected",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const FormSubmitAction: TrackingAction = {
  action: "form submitted",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const ButtonClickAction: TrackingAction = {
  action: "button clicked",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const RequestSubmitAction: TrackingAction = {
  action: "request submitted",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const TokenUseAction: TrackingAction = {
  action: "token used",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const IframeSubmitAction: TrackingAction = {
  action: "iframe credentials submitted",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const CredentialSuccessAction: TrackingAction = {
  action: "credentials retrieved",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const FinishSubmitAction: TrackingAction = {
  action: "finish submitted",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const PartSelectAction: TrackingAction = {
  action: "part selected",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const OpenSmartFaqAction: TrackingAction = {
  action: "smart faq opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const BaggageOrderFailedAction: TrackingAction = {
  action: "order failed",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

/*
 * DETAILS
 */
export const PrimaryEmailDetail = "Primary email change"

/*
 * API ACTIONS - for tracking via promise.js middleware
 * there actions are used in actionTypesToEventMapper.js
 * we cannot add verb at the end in action, because the verb will be filled in by track.js middleware
 */
export const PostFormAction: TrackingAction = {
  action: "post form",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
export const GetDataAction: TrackingAction = {
  action: "get data",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
